// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Pxi","col":"styles_col__hMV6Y"};